import { get, map, pipe, replace, uniq } from 'lodash/fp'

/**
 * Browser languages stripped to their base tag, e.g. ['en-US', 'de'] -> ['en', 'de'].
 */
export const detectNavigatorLanguages: (nav: unknown) => string[] = pipe([
  get('navigator.languages'),
  map(replace(/-.+/, '')),
  uniq,
])
